import './PageHeader.css';

/**
 * #124 — Cabeçalho de página canônico (padrão-ouro: Dashboard #52).
 * Props:
 *  - kicker?: label pequeno verde uppercase acima do título (opcional)
 *  - title: título da página (26px/700)
 *  - subtitle?: subtítulo discreto (opcional)
 *  - actions?: node renderizado à direita (botão primário, metadado, etc.)
 */
export default function PageHeader({ kicker, title, subtitle, actions }) {
  return (
    <header className="ui-page-header">
      <div className="ui-page-header__text">
        {kicker && <span className="ui-page-header__kicker">{kicker}</span>}
        <h1 className="ui-page-header__title">{title}</h1>
        {subtitle && <p className="ui-page-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="ui-page-header__actions">{actions}</div>}
    </header>
  );
}
